import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private poliza!: number;
  private num_documento!: string;

  setNumDocumento(numDocumento: string) {
    //console.log(numDocumento);
    this.num_documento = numDocumento;
    localStorage.setItem('num_documento', numDocumento);
  }

  getNumDocumento() {
    return this.num_documento || localStorage.getItem('num_documento') || '';
    // return this.num_documento || localStorage.getItem('num_documento') || '';
  }

  setPoliza(id: number) {
    this.poliza = id;
    localStorage.setItem('id_poliza', id.toString());
  }
  getPoliza() {
    return (
      this.poliza || parseInt(localStorage.getItem('id_poliza') ?? '0', 10)
    );
  }
}
